/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import productFlowService from './../../../../services/productFlow';
import productFlowTransformer from './../../../../transformers/productFlow';
import Forms from './../../../../utils/forms/forms';
import productService from './../../../../services/product';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        title: {
          value: '',
          type: 'text',
        },
        descriptions: {
          value: '',
          type: 'textarea',
        },
        orderId: {
          value: '',
          type: 'select',
        },
        productId: {
          value: '',
          type: 'select',
        },
        qty: {
          value:'',
          type: 'number',
        }
      }),
      loading: true,
      tabIndex: 'first',
    };
  },

  computed: {
    ...mapGetters({
      products: 'allProducts',
      orders: 'allproductFlowOrders'
    }),
  },

  watch: {

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} products    The products list.
     */
    products(products) {
      this.formBasicInformation.setOptions('productId', products.map(c => (
              { id: c.id, name:`${c.name }` }
      )));  
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} products    The products list.
     */
    orders(orders) {
      console.log(orders);
      this.formBasicInformation.setOptions('orderId', orders.map(c => (
              { id: c.id, name:`${c.name }` }
      )));  
    },
  },

  created() {
    
    this.loading = true;
    Promise.all([
      productService.all(),
      productFlowService.orders(),
    ]).then(() => {
      this.loading = false;
    });
  },

  methods: {
    /**
     * Method to store the client
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = productFlowTransformer.send(
        Object.assign({}, this.formBasicInformation.data())
      );
      productFlowService.store(client)
      .then(() => {
        this.$message({
          message: this.$t('static.productFlow.create.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'productFlow.index',
        });
      }).catch((errors) => {
       this.formBasicInformation.loading = false;
        this.loading = false;
        this.formBasicInformation.recordErrors(errors);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productFlow/create/create.js